export default "/images/ic-arrow-down.svg?c9d314acae56a4a516ffca1828347560";